import { ComponentBase } from '../component/component.base';
import { IComponentControlBase } from './component-control.interface';
import { Input } from '@angular/core';

export abstract class ComponentControlBase extends ComponentBase implements IComponentControlBase {
    
}